import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DenyExpensePresenter`

export default defineMessages({
  denySuccess: {
    id: `${scope}.denySuccess`,
    defaultMessage: 'Expense report #{expenseId} denied successfully',
  },
  denyError: {
    id: `${scope}.denyError`,
    defaultMessage: 'The expense request could not be denied. {error}',
  },
})
